import React from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
  Link,
  IconButton,
  Divider,
  useTheme,
} from "@mui/material";
import {
  Facebook as FacebookIcon,
  Instagram as InstagramIcon,
  Twitter as TwitterIcon,
  LinkedIn as LinkedInIcon,
} from "@mui/icons-material";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const isRtl = i18n.language === "ar";
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    { icon: <FacebookIcon />, name: "Facebook", url: "#" },
    { icon: <InstagramIcon />, name: "Instagram", url: "#" },
    { icon: <TwitterIcon />, name: "Twitter", url: "#" },
    { icon: <LinkedInIcon />, name: "LinkedIn", url: "#" },
  ];

  let logoUrl;
  try {
    logoUrl = require("../assets/Logo.png");
  } catch (error) {
    logoUrl = null;
  }
  let mainLogo;
  try {
    mainLogo = require("../assets/mainLogo.png");
  } catch (error) {
    mainLogo = null;
  }
  let appStore;
  try {
    appStore = require("../assets/AppStore.png");
  } catch (error) {
    appStore = null;
  }
  let googlePlay;
  try {
    googlePlay = require("../assets/GooglePlay.png");
  } catch (error) {
    googlePlay = null;
  }

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor:
          theme.palette.mode === "dark"
            ? theme.palette.background.paper
            : "##FFFFFF",
        pt: 6,
        pb: 3,
        borderTop: `1px solid ${theme.palette.divider}`,
        direction: isRtl ? "rtl" : "ltr",
        width: "100%",
      }}
    >
      <Container
        maxWidth={false}
        sx={{ maxWidth: "100%", px: { xs: 3, md: 6 } }}
      >
        <Grid container spacing={4} justifyContent="space-between">
          {/* Column 1: Logo */}
          <Grid
            item
            xs={12}
            sm={6}
            md={3}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="start"
              sx={{ gap: 2, mb: 2 }}
            >
              {logoUrl ? (
                <img
                  src={logoUrl}
                  alt="جمعيه التنميه الاهليه بالامواه"
                  style={{
                    height: "100px",
                    objectFit: "contain",
                  }}
                />
              ) : (
                <Typography
                  variant="h5"
                  component="div"
                  sx={{
                    fontWeight: "bold",
                    color: "#00AEE9",
                  }}
                >
                  {/* placeholder text if needed */}
                </Typography>
              )}
              {mainLogo ? (
                <img
                  src={mainLogo}
                  alt="جمعيه التنميه الاهليه بالامواه"
                  style={{
                    height: "85px",
                    objectFit: "contain",
                  }}
                />
              ) : (
                <Typography
                  variant="h5"
                  component="div"
                  sx={{
                    fontWeight: "bold",
                    color: "#00AEE9",
                  }}
                >
                  {/* placeholder text if needed */}
                </Typography>
              )}
            </Box>

            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Typography variant="h6" color="textSecondary">
                {t("productiveFamiliesMarket")}
              </Typography>
            </Box>
          </Grid>

          {/* Column 2: Buy, Rent and Sell */}
          <Grid
            item
            xs={12}
            sm={6}
            md={3}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: { xs: "center", sm: "flex-start" },
            }}
          >
            <Typography
              variant="h6"
              sx={{
                mb: 2,
                fontWeight: 600,
                fontSize: "1.1rem",
                color: theme.palette.text.primary,
                textAlign: { xs: "center", sm: isRtl ? "right" : "left" },
              }}
            >
              {t("contatct_us")}
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              <Link
                href="#"
                color="inherit"
                underline="hover"
                sx={{
                  color: theme.palette.text.secondary,
                  textAlign: { xs: "center", sm: isRtl ? "right" : "left" },
                }}
              >
                {t("appLocation")}
              </Link>
              <Link
                href="mailto:tanmiamwah@gmail.com"
                color="inherit"
                underline="hover"
                sx={{
                  color: theme.palette.text.secondary,
                  textAlign: { xs: "center", sm: isRtl ? "right" : "left" },
                }}
              >
                tanmiamwah@gmail.com
              </Link>

              <Link
                href="tel:056666666"
                color="inherit"
                underline="hover"
                sx={{
                  color: theme.palette.text.secondary,
                  textAlign: { xs: "center", sm: isRtl ? "right" : "left" },
                }}
              >
                056666666
              </Link>
            </Box>
          </Grid>

          {/* Column 3: About */}
          <Grid
            item
            xs={12}
            sm={6}
            md={3}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: { xs: "center", sm: "flex-start" },
            }}
          >
            <Typography
              variant="h6"
              sx={{
                mb: 2,
                fontWeight: 600,
                fontSize: "1.1rem",
                color: theme.palette.text.primary,
                textAlign: { xs: "center", sm: isRtl ? "right" : "left" },
              }}
            >
              {t("BankAccount")}
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: "bold",
                  color: theme.palette.text.secondary,
                  textAlign: { xs: "center", sm: isRtl ? "right" : "left" },
                  direction: "rtl",
                }}
              >
                {t("Al Rajhi Bank")}
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  color: theme.palette.text.secondary,
                  textAlign: { xs: "center", sm: isRtl ? "right" : "left" },
                  direction: "ltr",
                }}
              >
                SA48100000426135787456321
              </Typography>
            </Box>
          </Grid>

          {/* Column 4: Download App */}
          <Grid
            item
            xs={12}
            sm={6}
            md={3}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: { xs: "center", sm: "flex-start" },
            }}
          >
            <Typography
              variant="h6"
              sx={{
                mb: 2,
                fontWeight: 600,
                fontSize: "1.1rem",
                color: theme.palette.text.primary,
                textAlign: { xs: "center", sm: isRtl ? "right" : "left" },
              }}
            >
              {t("DOWNLOAD OUR APP")}
            </Typography>

            <Box
              sx={{
                display: "flex",
                gap: 2,
                mb: 3,
                flexDirection: "column",
                alignItems: { xs: "center", sm: "flex-start" },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                  alignItems: { xs: "center", sm: "flex-start" },
                }}
              >
                {appStore && (
                   <a
                    href="https://apps.apple.com/us/app/%D9%85%D9%86%D8%AA%D8%AC-%D8%A3%D8%B3%D8%B1%D9%8A/id6749048770"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={appStore}
                      alt="Download on the App Store"
                      style={{
                        width: "160px",
                        height: "auto",
                        maxWidth: "100%",
                        cursor: "pointer",
                      }}
                    />
                  </a>
                )}
                {googlePlay && (
                  <a
                    href="https://play.google.com/store/apps/details?id=com.dd.osra"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={googlePlay}
                      alt="Get it on Google Play"
                      style={{
                        width: "160px",
                        height: "auto",
                        maxWidth: "100%",
                        cursor: "pointer",
                      }}
                    />
                  </a>
                )}
              </Box>
            </Box>
          </Grid>
        </Grid>

        {/* Copyright and Social Media */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexDirection: { xs: "column", sm: "row" },
            gap: 2,
            mt: 4,
            pt: 3,
            borderTop: `1px solid ${theme.palette.divider}`,
          }}
        >
          <Typography variant="body2" color="text.secondary">
            {t("©2025 asra. All rights reserved")}
          </Typography>

          <Box sx={{ display: "flex", gap: 1 }}>
            {socialLinks.map((social, index) => (
              <IconButton
                key={index}
                aria-label={social.name}
                component={Link}
                href={social.url}
                target="_blank"
                rel="noopener"
                sx={{
                  color: theme.palette.text.secondary,
                  "&:hover": {
                    backgroundColor: "rgba(0, 174, 233, 0.1)",
                    color: "#00AEE9",
                  },
                }}
                size="small"
              >
                {social.icon}
              </IconButton>
            ))}
          </Box>
        </Box>
        {/* Developer Credit */}
        <Box
          sx={{
            mt: 2,
            textAlign: "center",
            color: theme.palette.text.secondary,
            fontSize: "0.85rem",
          }}
        >
          هذا الموقع والتطبيق (Android و iOS) تم تطويرهما بواسطة{" "}
          <Box component="span" sx={{ fontWeight: "bold" }}>
            Triple M Software House
          </Box>{" "}
          — للتواصل:{" "}
          <Link href="tel:01121656025" underline="hover" color="inherit">
            01121656025
          </Link>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
